interface Pos {
  x: number;
  y: number;
}

function numberToPx(n: number): string {
  return n + 'px';
}
function getAppropriateTiming(sourcePos: Pos, targetPos: Pos, maxTiming:number = 700, minTiming:number = 200) {
  const diff = maxTiming - minTiming;
  const maxDistance = document.body.clientHeight;
  let x = Math.sqrt(((sourcePos.x - targetPos.x) ** 2) + ((sourcePos.y - targetPos.y) ** 2)) / maxDistance;
  x = Math.min(x, 1);
  x = Math.max(x, 0);
  return Math.floor(diff * x + minTiming);
}
export function parabolaAnimation(sourcePos: Pos, targetPos: Pos, moving: HTMLElement) {
  return new Promise((resolve) => {
    // moving.style.transform = 'translate(-50%, -50%)';
    const container = document.querySelector('.robot-chat-wrapper');
    if (!container) {
      resolve(1);
      return;
    }
    const clientRect = container.getBoundingClientRect();
    moving.style.top = numberToPx(sourcePos.y - clientRect.y);
    moving.style.left = numberToPx(sourcePos.x - clientRect.x);
    
    container.appendChild(moving);
    requestAnimationFrame(() => {
      const timing = getAppropriateTiming(sourcePos, targetPos);
      moving.style.transition = `top ${timing}ms ease-in,left ${timing}ms linear`;
      moving.style.top = numberToPx(targetPos.y - clientRect.y);
      moving.style.left = numberToPx(targetPos.x - clientRect.x);
    });
    moving.addEventListener('transitionend', function () {
      moving && container.removeChild(moving);
      // @ts-expect-error
      moving = null;
      resolve(1);
    });
  });
}

export function textDebounceAnimation(target: HTMLElement) {
  return new Promise((resolve) => {
    // target.style.animation = 'autoScaling 0.4s';
    // target.style.transformOrigin = '50% 50%';
    target.addEventListener('animationend', function () {
      resolve(1);
    });
    
    requestAnimationFrame(() => {
      target.classList.add('text-debounce-animation');
    });
    
  });
}